import React from 'react';
import { Image } from 'antd';

const FALLBACK_SRC =
  'data:image/svg+xml,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120"><rect fill="#E5E5E5" width="120" height="120"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#98989A" font-size="12">No image</text></svg>',
  );

export const CustomImage = ({ src, alt = 'Image', preview = true, style, width, ...rest }) => {
  const [imageSrc, setImageSrc] = React.useState(src || FALLBACK_SRC);

  React.useEffect(() => {
    setImageSrc(src || FALLBACK_SRC);
  }, [src]);

  const handleError = () => {
    setImageSrc(FALLBACK_SRC);
  };

  return (
    <Image
      src={imageSrc}
      alt={alt}
      preview={preview}
      onError={handleError}
      style={{
        objectFit: 'cover',
        width: width || '100%',
        height: 'auto',
        ...style,
      }}
      {...rest}
    />
  );
};
